import type { RouteLocationRaw } from 'vue-router';
import router from '../../../../vue/router';
import type { CustomRoute } from '../../../../vue/routes';
import { useUserStore } from '@/vue/stores/user';

export default (location: RouteLocationRaw): boolean => {
    const { permissions: getPermissions } = router.resolve(location).meta as CustomRoute['meta'];

    if (!getPermissions) {
        return false;
    }

    const permissions = getPermissions();

    return permissions.length === 0 || permissions.some(useUserStore().hasPermission);
};
